import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-card.tsx
var LazyCardFrame = lazy(() => import("./card-frame-BMI32BoD.js").then((n) => n.n).then((module) => ({ default: module.CardFrame })));
function CardFrame({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "card-frame" }),
		children: /* @__PURE__ */ jsx(LazyCardFrame, { ...props })
	});
}
var LazyCard = lazy(() => import("./card-BD3PzQt4.js").then((n) => n.n).then((module) => ({ default: module.Card })));
function Card({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "card" }),
		children: /* @__PURE__ */ jsx(LazyCard, { ...props })
	});
}
function CardContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "card" }),
		children: /* @__PURE__ */ jsx(LazyCard, { ...props })
	});
}
var useCardContent = () => {
	return useMemo(() => ({ card: { component: CardContent } }), []);
};
//#endregion
export { Card, CardFrame, useCardContent };
